
export default {
  invoices: [],
  invoicesByArtisan: []
}
